module.exports = __webpack_public_path__ + "static/media/about1.0a04dae3.svg";